import { render, staticRenderFns } from "./ArrowTrendingDown.vue?vue&type=template&id=baf88f50&"
import script from "./ArrowTrendingDown.vue?vue&type=script&lang=ts&"
export * from "./ArrowTrendingDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports